import GuiContext from "config/context/guiContext";
import { useContext, useState } from "react";
import { useCompositionsContext } from "../context/CompositionsContext";

const initialServerStatus = {
    response: null,
    loading: false,
    error: null,
}

export const useGetCompositionScopesService= () => {
    const { setSelectedComposition } = useCompositionsContext();
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const {
        selected: { selectedAccount, selectedServer },
        URL
    } = useContext(GuiContext);

    const getCompositionScopes = async ({composition}) => {
        setLoading(true);
        try {
            const res = await fetch(`${URL}/api/database/composition_scopes`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    database: selectedAccount || "",
                    server_url: selectedServer || "",
                    composition: composition
                }),
            });

            const data = await res.json();
            setResponse(data);
            setSelectedComposition(prev => ({
                ...prev,
                scopes: data.scopes?.map(scopeItem => ({
                    scope: scopeItem.scope,
                    count: scopeItem.count
                })) || []
            }))
            if (!data?.status) {
                setError(data?.message);
            }
        } catch (err) {
            setError(err.message || 'An error occurred');
        } finally {
            setLoading(false);
        }
    }

      const resetServerStatus = () => {
        setLoading(initialServerStatus.loading);
        setResponse(initialServerStatus.response);
        setError(initialServerStatus.error);
    }

    return {
        response,
        loading,
        error,
        getCompositionScopes,
        resetServerStatus
    }
}